module.exports = __webpack_public_path__ + "static/media/015yhkgl.faafc5ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/015yhkgl.jpg
// module id = 634
// module chunks = 0 1